import { type ReactNode } from 'react';
import * as stylex from '@stylexjs/stylex';
import { sentinel } from '../theme/semantic.stylex';

const styles = stylex.create({
  row: { display: 'grid', gap: '0.25rem' },
  error: { color: sentinel.textError, fontSize: '0.875rem' },
});

export function FieldRow({ children }: { children: ReactNode }) {
  return <div {...stylex.props(styles.row)}>{children}</div>;
}

export function FieldError({ message }: { message?: string | undefined }) {
  return message ? (
    <span role="alert" {...stylex.props(styles.error)}>
      {message}
    </span>
  ) : null;
}
